import { useTranslation } from "react-i18next";
import { listConnectors } from "../../../api/connectorsApi";
import { useLoad } from "../../../shared/loading/useLoad";
import OptionCard from "../../../ui/forms/OptionCard";
import { agentLevelsOf, levelChoices, STANDARD_LEVEL } from "./reasoningLevels";
import { changePreferences, useUserPreferences } from "./userPreferences";

/** The person's reasoning level per agent their PCs report, over the installation's: one card per agent that offers levels. */
export default function ReasoningLevelCards({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation();
  const { preferences } = useUserPreferences();
  const { state } = useLoad(listConnectors);
  if (state.status !== "loaded") return null;
  return agentLevelsOf(state.value).map((agent) => {
    const own = preferences.reasoningLevels[agent.agentId];
    return (
      <OptionCard
        key={agent.agentId}
        label={t("profile.reasoningLevel", { agent: agent.title })}
        value={own ?? STANDARD_LEVEL}
        options={levelChoices(agent, preferences.installationReasoningLevels[agent.agentId], own, t)}
        onChange={(level) => void changePreferences({ reasoningLevel: { agentId: agent.agentId, effortId: level === STANDARD_LEVEL ? null : level } })}
        disabled={disabled}
      />
    );
  });
}
